quoteModule.controller('vehicleRateController',
    ['$scope', '$rootScope',  'growl', 'vehicleProductCoordService', 'quoteCreationEvents',
        'rateQuoteCoordService','rateQuoteScenariosService', 'contractInfoService', 'vehicleRateService',
        'rateQuotePersistService','financeService','imSessionVarsService','erateSessionVarsService',
        function ($scope, $rootScope, growl, vehicleProductCoordService, quoteCreationEvents,
                  rateQuoteCoordService,rateQuoteScenariosService, contractInfoService, vehicleRateService,
                  rateQuotePersistService,financeService,imSessionVarsService,erateSessionVarsService
        )
        {
            /*
             The vehicle rate controller handles building the rate request, retrieving the rates,
             retrieving an existing quote, and selecting a rate to put in the "contract queue"
             */

            $scope.$watch('prodid', function(newVal) {
                if(newVal)
                    vehicleRateService.onFinishRateProcessing(newVal, updateRateInfo);
            });

            function CheckGap() {
                var isProdGap = false;

                for (i = 0; i < $scope.rateProductInfo.rates.Rates.length; i++) {
                    if (($scope.rateProductInfo.rates.Rates[i].RatedProduct.DisplayName.toUpperCase().indexOf('GAP') > -1)
                        ||   (($scope.rateProductInfo.rates.Rates[i].RatedProduct.PartnerCode != null)
                            && ($scope.rateProductInfo.rates.Rates[i].RatedProduct.PartnerCode.toUpperCase().indexOf('GAP') > -1)))
                    {
                        isProdGap = true;
                        break;
                    }

                }
                return isProdGap;
            }

             //we have 'clicked' on a term
            $scope.selectRateTerm = function(termId,retailCost) {
                //create a copy of the object
                var rateClone = angular.copy($scope.rateProductInfo.rates);
                var validRate = null;
                var cachedRateResponseId = $scope.rateProductInfo.rates.CachedResponseId;

                var currentRate = rateQuoteCoordService.getRateForScenarioCodeProductId(
                    rateQuoteScenariosService.getCurrentScenario(),
                    $scope.rateProductInfo.chosenProductCode);
                if (currentRate && currentRate.RatedTerms[0].SavedRateUniqueId){
                    var quoteid = currentRate.RatedTerms[0].SavedRateUniqueId;
                    if (contractInfoService.contractsPerQuote[quoteid] &&
                        contractInfoService.contractsPerQuote[quoteid].length > 0){
                        growl.warning("Contract already associated. Cannot change the term.");
                        return;
                    }
                }
                var p = $scope.rateProductInfo.rates.Rates[0].RatedProduct.ParentProductType.ParentProductRatingCategory;
                var prodRateTypeCode = getRatedProductCatFlexField(p,'COMMERCE-RATE-TYPE') ? getRatedProductCatFlexField(p,'COMMERCE-RATE-TYPE') : p.ApplicationCode;

                var otherProdSameType = rateQuoteCoordService.getRateForScenarioCodeProductType(rateQuoteScenariosService.getCurrentScenario(),
                    prodRateTypeCode
                    );

                if (otherProdSameType && otherProdSameType.RatedTerms[0].SavedRateUniqueId){
                    var otherquoteid = otherProdSameType.RatedTerms[0].SavedRateUniqueId;
                    if (contractInfoService.contractsPerQuote[otherquoteid] &&
                        contractInfoService.contractsPerQuote[otherquoteid].length > 0){
                        $rootScope.$broadcast(quoteCreationEvents.invalidProductTypeChosenContract,{prodId : $scope.rateProductInfo.rates.Rates[0].RatedProduct.InternalProductId});
                        return;
                    }
                }

                for (i=0; i < rateClone.Rates.length && validRate == null; i++) {
                    //checking based on whether it is an upgradeable product or not
                    if ($scope.rateProductInfo.chosenUpgradeCoverageCode){
                        if (rateClone.Rates[i].RatedProduct.InternalProductId.toUpperCase() == $scope.rateProductInfo.chosenProductCode.toUpperCase() &&
                            rateClone.Rates[i].RatedCoverage.InternalCoverageId.toUpperCase() == $scope.rateProductInfo.chosenUpgradeCoverageCode.toUpperCase() &&
                            rateClone.Rates[i].RatedDeductible.InternalDeductibleId.toUpperCase() == $scope.rateProductInfo.chosenUpgradeDeductibleCode.toUpperCase()
                        )
                        {
                            validRate = rateClone.Rates[i];
                        }
                    }else{
                        if (rateClone.Rates[i].RatedDeductible == null &&
                            rateClone.Rates[i].RatedProduct.InternalProductId.toUpperCase() == $scope.rateProductInfo.chosenProductCode.toUpperCase() &&
                            rateClone.Rates[i].RatedCoverage.InternalCoverageId.toUpperCase() == $scope.rateProductInfo.chosenCoverageCode.toUpperCase()){
                            validRate = rateClone.Rates[i];
                        }
                        else if ($scope.rateProductInfo.chosenProductCode.toUpperCase().indexOf((rateClone.Rates[i].RatedProduct.InternalProductId ? rateClone.Rates[i].RatedProduct.InternalProductId.toUpperCase() : '')) >= 0 &&
                            rateClone.Rates[i].RatedCoverage.InternalCoverageId.toUpperCase() == $scope.rateProductInfo.chosenCoverageCode.toUpperCase() &&
                            rateClone.Rates[i].RatedDeductible.InternalDeductibleId.toUpperCase() == $scope.rateProductInfo.chosenDeductibleCode.toUpperCase()
                        )
                        {
                            validRate = rateClone.Rates[i];
                        }
                    }
                }
                //did we find it?
                if (!validRate){
                    throw new Error('Could not find rate ' + $scope.rateProductInfo.chosenProductCode.toUpperCase() + ' ' + $scope.rateProductInfo.chosenCoverageCode.toUpperCase() +
                    ' ' + $scope.rateProductInfo.chosenCoverageCode.toUpperCase());
                }
                rateClone = validRate;
                var cachedProductResponseId = vehicleProductCoordService.getProductData(validRate.RatedProduct.InternalProductId) != null ? vehicleProductCoordService.getProductData(validRate.RatedProduct.InternalProductId).cachedResponseId : null;
                var validTerm = null;
                for (i=0; i < rateClone.RatedTerms.length && validTerm == null; i++){
                    if (rateClone.RatedTerms[i].RatedTerm.InternalTermId.toUpperCase() == termId.toUpperCase()  &&
                        rateClone.RatedTerms[i].RetailCost == retailCost
                    ){
                        validTerm = rateClone.RatedTerms[i];
                    }
                }
                if (!validTerm){
                    throw new Error('Could not find term ' + termId);
                }
                //check upgrades
                if (!(rateClone.BaseNoUpgradeProductRates && rateClone.BaseNoUpgradeProductRates.length > 0 && retailCost > 0)){
                    rateClone.BaseNoUpgradeProductRates = null;
                }

                rateClone.RatedTerms = [validTerm];
                //sets the 'selected term'
                $scope.chooseTermInfo(termId);
                //set the quote/contract queue
                rateQuoteCoordService.holdRateForQuote(rateClone, rateQuoteScenariosService.getCurrentScenario(),cachedProductResponseId,cachedRateResponseId);
                $rootScope.$broadcast(quoteCreationEvents.refreshQuoteQueue,{ reRate: false });
                $rootScope.$broadcast(quoteCreationEvents.attemptQuoteSave,{});
                $rootScope.$broadcast(quoteCreationEvents.rateChosen, validRate.RatedProduct.InternalProductId);
                $rootScope.$broadcast(quoteCreationEvents.productTypeChosen, validRate.RatedProduct);
                $rootScope.$broadcast(quoteCreationEvents.quoteRemovedFromScenario,{});
                currentRate = otherProdSameType = null;
            };

            var getRatedProductCatFlexField = function(productCat, fieldName) {
                var flexFields = productCat
                    && productCat.PartnerSpecificFields
                    && productCat.PartnerSpecificFields.FlexFields
                    && productCat.PartnerSpecificFields.FlexFields;

                if (!angular.isArray(flexFields))
                    return angular.undefined;

                var field = _.find(flexFields, function (fieldObj) { return fieldObj.FieldName == fieldName});

                return field && field.FieldValue;
            }

            var updateRateInfo = function() {
                $scope.rateProductInfo = vehicleRateService.rateProductInfos[$scope.prodid];
                setViewType($scope.prodid);
            };

            var setViewType = function(productId) {
                if (vehicleRateService.rateProductInfos[productId].milesTerms.length === 1) {
                    $scope.viewMode = $scope.viewModeTypes.slim;
                }
                else {
                    $scope.viewMode = $scope.viewModeTypes.normal;
                }
            };

            //set the chosen term
            $scope.chooseTermInfo = function(termid){
                $scope.rateProductInfo.chosenTermInternalId = termid;
            };

            //if the rate in the queue matches the chose product options,
            // make sure the "chosen term" is set accordingly
            $scope.synchupRateInQueueWithRatesGrid = function(){
                if(!$scope.rateProductInfo || $scope.rateProductInfo.productid === null)
                    return;
                $scope.rateProductInfo.chosenTermInternalId = null;
                // If the productId is null then the chosen product does not have enough
                // information to have a Quote/Rate. Therefor we have no reason to try
                // sync the data.

                var myRate = rateQuoteCoordService.getRateForScenarioCodeProductId(
                    rateQuoteScenariosService.getCurrentScenario(),
                    $scope.rateProductInfo.productid
                );
                if (myRate != null){
                    var ratedCov = myRate.BaseNoUpgradeProductRates ? myRate.BaseNoUpgradeProductRates[0].BaseRatedCoverage : myRate.RatedCoverage;
                    var ratedDed = myRate.BaseNoUpgradeProductRates ? myRate.BaseNoUpgradeProductRates[0].BaseRatedDeductible : myRate.RatedDeductible;
                    var ratedNoUpTerm = myRate.BaseNoUpgradeProductRates ? myRate.BaseNoUpgradeProductRates[0].BaseRatedTerm.RatedTerm : null;
                    var ratedUpCoverage = myRate.BaseNoUpgradeProductRates ? myRate.RatedCoverage : null;
                    var ratedUpDed = myRate.BaseNoUpgradeProductRates ? myRate.RatedDeductible : null;
                    //does the rate in the queue match up with the rates we just got??
                    if ($scope.rateSynchsWithChosenProductOptions(
                            ratedCov, ratedDed, ratedNoUpTerm, ratedUpCoverage, ratedUpDed
                        )) {
                        $scope.chooseTermInfo(myRate.RatedTerm ? myRate.RatedTerm.InternalTermId : myRate.RatedTerms[0].RatedTerm.InternalTermId);
                    }
                }
                myRate = null;
            };
            //determine if chosen product options matches the current rate (in queue)
            $scope.rateSynchsWithChosenProductOptions = function(Coverage, Deductible, NoUpgradeTerm, UpgradeCoverage, UpgradeDeductible){
                if ($scope.rateProductInfo.chosenCoverageCode != Coverage.InternalCoverageId)
                    return false;
                if (Deductible != null && $scope.rateProductInfo.chosenDeductibleCode != Deductible.InternalDeductibleId)
                    return false;
                if (!($scope.rateProductInfo.chosenBaseNoUpgradeTerm == null || ($scope.rateProductInfo.chosenBaseNoUpgradeTerm && NoUpgradeTerm && NoUpgradeTerm.InternalTermId && $scope.rateProductInfo.chosenBaseNoUpgradeTerm == NoUpgradeTerm.InternalTermId)))
                    return false;
                if (!($scope.rateProductInfo.chosenUpgradeCoverageCode == null || ($scope.rateProductInfo.chosenUpgradeCoverageCode && UpgradeCoverage && $scope.rateProductInfo.chosenUpgradeCoverageCode == UpgradeCoverage.InternalCoverageId)))
                    return false;
                if (!($scope.rateProductInfo.chosenUpgradeDeductibleCode == null || ($scope.rateProductInfo.chosenUpgradeDeductibleCode && UpgradeDeductible && $scope.rateProductInfo.chosenUpgradeDeductibleCode == UpgradeDeductible.InternalDeductibleId)))
                    return false;
                return true;
            };
            //respond to changing the proposal
            $scope.$on(quoteCreationEvents.scenarioChanged, function(event, args) {
                $scope.synchupRateInQueueWithRatesGrid();
            });
            //respond to removing quote from proposal
            $scope.$on(quoteCreationEvents.quoteRemovedFromScenario, function(event, args) {
                $scope.synchupRateInQueueWithRatesGrid();
            });
            $scope.$on(quoteCreationEvents.productTypeChosenEmit, function(event, args) {
                if ($scope.rateProductInfo && $scope.rateProductInfo.chosenProductTypeCode === args.ParentProductType.ApplicationCode && $scope.rateProductInfo.productid != args.InternalProductId) {
                    $scope.rateProductInfo.chosenTermInternalId = null;
                }
            });

            $scope.viewModeTypes = {
                none: "NONE",
                normal: "NORMAL",
                slim: "SLIM"
            };

            $scope.viewMode = $scope.viewModeTypes.none;
        }]);
